<div [ngSwitch]="currentStep">
    <div *ngSwitchCase="Step.TAB_TYPE">
        <div>Select Human Insight or Performance Insight</div>
        <button
            class="btn bg-transparent"
            (click)="selectUser.emit()"
        >
            <cmps-icon
                class="cmps-cdk-fill-grey-300 cmps-cdk-mr-0dot25"
                svgIcon="account-circle"
            ></cmps-icon>
            <span>Human Insight</span>
        </button>
        <button
            class="btn bg-transparent"
            (click)="
                selectedTabType = TabType.PERFORMANCE; currentStep = Step.WIZARD
            "
        >
            <cmps-icon
                class="cmps-cdk-fill-grey-300 cmps-cdk-mr-0dot25"
                svgIcon="chart-box-outline"
            ></cmps-icon>
            <span>Performance Insight</span>
        </button>
    </div>
    <ng-container *ngSwitchCase="Step.WIZARD">
        <ng-container [ngSwitch]="selectedTabType">
            <div
                *ngSwitchCase="TabType.PERFORMANCE"
                cmpsPerformanceInsightWizard
                (tabCreate)="tabCreate.emit($event)"
            ></div>
        </ng-container>
    </ng-container>
</div>
